import { MicrophoneStreamContext } from '@core/components/MicrophoneStreamProvider/MicrophoneStreamProvider';
import { useContext, useEffect } from 'react';

/** @type {(echoCancellation: boolean)} */
export const useAutoStartMicStream = (echoCancellation) => {
  const { startStream } = useContext(MicrophoneStreamContext);
  useEffect(() => {
    const start = async () => {
      await startStream(echoCancellation);
    };
    start();
  }, [startStream, echoCancellation]);
};
